var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeriskingFreeShipping = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99989 0.249512L7.98982 6.86046L13.9998 7.94939L7.98982 9.03832L6.99989 15.6493L6.00995 9.03832L0 7.94939L6.00995 6.86046L6.99989 0.249512Z",
    fill: "#4D523C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5014 5.85107L26.1843 16.9695L36.4012 18.8009L26.1843 20.6322L24.5014 31.7507L22.8185 20.6322L12.6016 18.8009L22.8185 16.9695L24.5014 5.85107Z",
    fill: "#4D523C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeriskingFreeShipping);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzNyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuOTk5ODkgMC4yNDk1MTJMNy45ODk4MiA2Ljg2MDQ2TDEzLjk5OTggNy45NDkzOUw3Ljk4OTgyIDkuMDM4MzJMNi45OTk4OSAxNS42NDkzTDYuMDA5OTUgOS4wMzgzMkwwIDcuOTQ5MzlMNi4wMDk5NSA2Ljg2MDQ2TDYuOTk5ODkgMC4yNDk1MTJaIiBmaWxsPSIjNEQ1MjNDIi8+CjxwYXRoIGQ9Ik0yNC41MDE0IDUuODUxMDdMMjYuMTg0MyAxNi45Njk1TDM2LjQwMTIgMTguODAwOUwyNi4xODQzIDIwLjYzMjJMMjQuNTAxNCAzMS43NTA3TDIyLjgxODUgMjAuNjMyMkwxMi42MDE2IDE4LjgwMDlMMjIuODE4NSAxNi45Njk1TDI0LjUwMTQgNS44NTEwN1oiIGZpbGw9IiM0RDUyM0MiLz4KPC9zdmc+Cg==";